export default {
    COLETA: 1,
    LABORATORIO: 2,
    UNIDADE_SOLICITANTE: 3,
    AMBOS: 4
}